import React, { useContext } from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Button, Grid, Typography } from '@material-ui/core';
import axios from 'axios';
import { useRouter } from 'next/router';
import { carrierId, stagingServerUrl } from '../../../server/constants';
import { SnackbarContext } from '../../Snackbar/Context';
import {
  ErrorCommon,
  FormikValues,
  FormWrap,
  Label,
  PhoneNumberField,
  TextField,
  TextFieldCommon
} from '../../formikFormInputs';
import { unmaskPhoneNumber } from '../../../utils/commonUtils';
import { initFalse } from '../../../utils/constants';
import { SnackBarSeverity } from '../../../utils/enums';
import { email as emailValidation, phoneNumber, required } from '../../../utils/validation';


interface EmailFormInterface {
  isUnderstandDisclaimer: boolean;
  setOpenDialog: Function;
}

interface EmailFormValues {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}


export default function EmailForm(props: EmailFormInterface) {
  const {isUnderstandDisclaimer, setOpenDialog} = props;
  const snackbar = useContext(SnackbarContext);

  const [formValues, setFormValues] = React.useState<EmailFormValues>({} as EmailFormValues);

  const router = useRouter();

  const fieldObj = [
    {
      component: TextField,
      id: 'firstName',
      label: <Label label={'Your First Name'} required={!initFalse} />,
      name: 'firstName',
      placeholder: 'Your First Name',
      rowSize: 6,
      validate: required,
    },
    {
      component: TextField,
      id: 'lastName',
      label: <Label label={'Your Last Name'} required={!initFalse} />,
      name: 'lastName',
      placeholder: 'Your Last Name',
      rowSize: 6,
      validate: required,
    },
    {
      component: TextField,
      id: 'email',
      label: <Label label={'Your Email'} required={!initFalse} />,
      name: 'email',
      placeholder: 'Email',
      rowSize: 6,
      validate: emailValidation,
    },
    {
      component: PhoneNumberField,
      id: 'phone',
      label: <Label label={'Your Phone'} required={!initFalse} />,
      name: 'phone',
      placeholder: 'Phone',
      rowSize: 6,
      validate: phoneNumber,
    }
  ];
  const initialValues: EmailFormValues = {email: '', firstName: '', lastName: '', phone: ''};

  React.useEffect(() => {
    if (isUnderstandDisclaimer) {
      saveLead(formValues);
    }
  }, [isUnderstandDisclaimer]);

  const postMarketingEmail = async (email: string) => {
    const [marketingEmailUrl, headers, payload] = [
      `${stagingServerUrl}/marketingemail`,
      {},
      {email: email, strategyId: 1, agentLinkId: 0}
    ];

    return axios.post(marketingEmailUrl, payload, {headers: headers});
  };

  const dupeEmailCheck = async (email: string) => {
    const dupeEmailCheckUrl = `${stagingServerUrl}/leads/duplicate-check?email=${encodeURIComponent(email)}&isEncoded=true`;
    return axios.get(dupeEmailCheckUrl);
  };

  const onSubmit = async (values: FormikValues) => {
    await postMarketingEmail(values.email);

    await dupeEmailCheck(values.email)
      .then((res: any) => {
        if (res.data && res.data.length > 0) {
          console.info(res.data);
          snackbar.showMessage(res.data, SnackBarSeverity.Error);
        } else {
          setOpenDialog(!initFalse);
          setFormValues(values as EmailFormValues);
        }
      })
      .catch((error: any) => {
        console.log(error);
        console.log(error && error.response && error.response.data && error.response.data.message);
        snackbar.showMessage(error && error.response && error.response.data && error.response.data.message, SnackBarSeverity.Error);
      });
  };

  const saveLead = (data: any) => {
    const [leadsUrl, payload] = [`${stagingServerUrl}/leads`, {
      'agentId': 0,
      'agentLinkId': 0,
      'carrierId': carrierId,
      'contactType': '',
      'contribution': 38350,
      'email': data.email,
      'firstName': data.firstName,
      'healthType': 'Standard',
      'householdIncome': 200000,
      'lastName': data.lastName,
      'leadSource': 'niwcorp.com',
      'phone': unmaskPhoneNumber(data.phone),
      'specificDate': undefined,
      'specificTime': undefined,
      'strategyId': 1,
      'strategyLabel': 'Kai-Zen',
    }];

    axios.post(leadsUrl, payload)
      .then(async (res: any) => {
        await router.replace(`${router.pathname}?email=${encodeURIComponent(data.email)}&landing=1&id=${res.data.id}`);
        const qDiv = document.getElementById('questionDiv');
        if (qDiv) {
          qDiv.scrollIntoView({behavior: 'auto', block: 'center', inline: 'center'});
        }
      })
      .catch((error: any) => {
        const msg: any = error && error.response && error.response.data && error.response.data.message;
        // setEmailError(msg);
        console.info(msg)
        snackbar.showMessage(msg, SnackBarSeverity.Error);

        return router.reload();
      });

  };


  const formProps = {
    children: ({dirty, errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values}: any) =>
      (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {
              fieldObj.map((field, index) => {
                return (
                  <Grid
                    item xs={12} md={6} key={index}
                  >
                    <TextFieldCommon
                      {...field} values={values} onChange={handleChange} onBlur={handleBlur}
                    />
                    <ErrorCommon
                      errors={errors} name={field.name} touched={touched}
                    />
                  </Grid>
                )
              })
            }
          </Grid>
          <Grid item xs={12} className="textCenter positionR">
            <Button
              className={(!(((Object.keys(errors).length !== 0) || !dirty || isSubmitting))) ? 'glow customBtn mt20 mb20' : 'customBtn mt20 mb20 '}
              variant="contained"
              type={'submit'}
              disabled={((Object.keys(errors).length !== 0) || !dirty || isSubmitting)}
              endIcon={<ArrowForwardIcon />}
            >
              Get Free Estimate
            </Button>
            <div className="arrow" style={{top:20}}/>
            <Typography className="textCenter w100 floatLeft textLightGray f12 mb20">
              By proceeding you agree to our <a href="https://www.niwcorp.com/privacy-policy" target="_blank" className="itemHover"
            >privacy terms</a> and to be
              <br />
              contacted by a NIW specialist.
            </Typography>

          </Grid>
        </form>
      ),
    initialValues,
    onSubmit
  };

  return (
    <FormWrap  {...formProps} />
  );
}
